export var RECOMMENDER_DESKTOP_LIMIT = 30;
export var RECOMMENDER_MOBILE_LIMIT = 20;
export var RECOMMENDER_EVENT_LIMIT = 20;
export var PERSONALISED_RECOMMENDER_TITLE_EXPERIMENT = "personalised_recommender_title_july_2022";
export var RECENTLY_VIEWED_TITLE_EXPERIMENT = "recently_viewed_recommender_title_july_2022";
export var INCOMPATIBLE_RECOMMENDATIONS_PVAV_EXPERIMENT = "incompatible_electronic_recommendations_june_22";
export var SIMILAR_PRODUCT_RECOMMENDER_EXPERIMENT = "similar_product_recommendation_experiment";
export var PERSONALISED_PRODUCT_RECOMMENDER_EXPERIMENT = "personalised_recommender_on_product_page_may_22";
export var BRAND_SLUGS_WITH_RESTRICTED_RECOMMENDERS = ["apple"]; // 2440: Dyson

export var SELLER_IDS_WITH_RESTRICTED_RECOMMENDERS = ["2440"];